
import React, { useState } from 'react';

export default function AccountSettingsPage() {
  const [birthdate, setBirthdate] = useState('1992-05-23');
  const [gender, setGender] = useState('Homme');
  const [country, setCountry] = useState('Tunisie');
  const [language, setLanguage] = useState('fr');

  const handleConvertClick = () => {
    alert("Fonction de conversion de compte à implémenter.");
  };

  const handleDeactivateClick = () => {
    alert("Fonction de désactivation à implémenter.");
  };

  return (
    <div className="container-fluid pt-5" style={{ paddingLeft: "100px", width: "100%" }}>
      <div className="row g-4">
        <div className="col-md-3 border-end pe-3">
          <div className="list-group">
            <button className="list-group-item list-group-item-action active">
              Gestion de votre compte
            </button>
          </div>
        </div>

        <div className="col-md-9">
          <h2 className="mb-4">Votre compte</h2>

          <div className="mb-3">
            <label className="form-label">Adresse e-mail</label>
            <input type="email" className="form-control" value="akremanaya@gmail.com" disabled />
          </div>

          <div className="mb-3">
            <label className="form-label">Mot de passe</label>
            <div className="d-flex align-items-center">
              <input type="password" className="form-control me-2" value="********" disabled />
              <button className="btn btn-secondary">Modifier</button>
            </div>
          </div>

          <div className="mb-5">
            <label className="form-label">Passez à un compte professionnel</label>
            <p className="text-muted">Avec un compte professionnel, vous aurez accès à des outils tels que les annonces et les statistiques pour développer votre activité.</p>
            <button className="btn btn-outline-dark" onClick={handleConvertClick}>Convertir le compte</button>
          </div>

          <h5 className="mb-3">Informations personnelles</h5>

          <div className="mb-3">
            <label className="form-label">Date de naissance</label>
            <input
              type="date"
              className="form-control"
              value={birthdate}
              onChange={e => setBirthdate(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Identité de genre</label>
            <div>
              {["Homme", "Femme", "Non binaire"].map((option) => (
                <div className="form-check form-check-inline" key={option}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="gender"
                    id={`gender-${option}`}
                    value={option}
                    checked={gender === option}
                    onChange={e => setGender(e.target.value)}
                  />
                  <label className="form-check-label" htmlFor={`gender-${option}`}>
                    {option}
                  </label>
                </div>
              ))}
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label">Pays/Région</label>
            <select className="form-select" value={country} onChange={e => setCountry(e.target.value)}>
              <option value="Tunisie">Tunisie</option>
              <option value="France">France</option>
              <option value="Canada">Canada</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="form-label">Langue</label>
            <select className="form-select" value={language} onChange={e => setLanguage(e.target.value)}>
              <option value="fr">Français</option>
              <option value="en">English</option>
              <option value="ar">العربية</option>
            </select>
          </div>

          <h5 className="mb-3">Désactivation et suppression</h5>

          <div className="mb-3">
            <p className="text-muted">Masquez temporairement votre profil ou désactivez votre compte.</p>
            <button className="btn btn-outline-danger" onClick={handleDeactivateClick}>Désactiver le compte</button>
          </div>
        </div>
      </div>
    </div>
  );
}
